import api from './api';

const base = (partnerId, token) => `/public/affiliate-intake/${partnerId}/${token}`;

export const getIntakeProfile = (partnerId, token) =>
  api.get(base(partnerId, token)).then(r => r.data);

export const submitIntakeProfile = (partnerId, token, fields) =>
  api.post(base(partnerId, token), fields).then(r => r.data);

export const uploadIntakePhoto = (partnerId, token, file) => {
  const formData = new FormData();
  formData.append('image', file);
  return api.post(`${base(partnerId, token)}/photo`, formData, { headers: { 'Content-Type': undefined } }).then(r => r.data.url);
};

export const uploadIntakeVideo = (partnerId, token, which, file) => {
  const formData = new FormData();
  formData.append('video', file);
  return api.post(`${base(partnerId, token)}/video/${which}`, formData, { headers: { 'Content-Type': undefined } }).then(r => r.data);
};
